import { observer } from 'mobx-react';
import { useConfigureRollbar } from './use-configure-rollbar';
import { ConfigureRollbarProps } from './configure-rollbar.types';

export const ConfigureRollbar = observer(({ router, user, ui }: ConfigureRollbarProps): null => {
  useConfigureRollbar({
    router,
    user,
    ui,
  });

  return null;
});
